import React from 'react';
export function Footer() {
  return <footer className="w-full py-6 px-4" data-id="element-4">
      <div className="container mx-auto text-center text-gray-500 text-sm" data-id="element-5">
        <p data-id="element-6">© {new Date().getFullYear()} alcre.ai - All rights reserved</p>
      </div>
    </footer>;
}